const BACKEND_URL = "https://scoreboard.flappysat.space"
// const BACKEND_URL = "https://flappysat.alastair.ax";

export class Scoreboard{
	score: number;
	score_element: Element | null;

	remaining_score_to_add: number;
	interval_id: number;

	lives_element: Element | null;
	n_lives: number;

	game_over_callback : Function;

	current_rank : number;
	token: number;
	last_update_score: number;
	total_games_played: number;

	constructor(game_over_callback: Function){
		this.game_over_callback = game_over_callback;
		this.score = 0;
		this.score_element = document.querySelector("#scoreboard");

		this.remaining_score_to_add = 0;

		this.n_lives = 5;
		this.lives_element = document.querySelector("#lives");

		this.token = 0;
		this.last_update_score = 0;
		this.total_games_played = 0;
		this.current_rank = 0;

		// Try and get ourselves a token from the server
		fetch(BACKEND_URL+"/token")
			.then(response => response.json())
			.then(data => {
				this.token = data.token;
				console.log("Received token: " + this.token);
			});
	}

	decrement_and_draw_remaining_lives = () => {
		console.log("Decrement");
		this.n_lives -= 1;
		if(this.n_lives <= 0){
			this.game_over_callback();
		}
		const lives_to_hide = 5 - this.n_lives;
		for(let i = 0; i < lives_to_hide; i++){
			const child = this.lives_element.children[i];
			if(child){
				child.style.visibility = "hidden";
			}
		}
	}

	timer_callback = () => {
		if(this.remaining_score_to_add <= 0){
			clearInterval(this.interval_id);
			return;
		}
		this.score +=1;
		this.remaining_score_to_add -=1;
		this.update_scoreboard();
	}

	update_server = (new_score: number): Promise<Response> =>{
		console.log("Attempting to update server");
		return fetch(
			BACKEND_URL+"/update_score",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					token: this.token,
					score: Math.round(new_score),
				})
			}

		);
	}

	request_country_leaderboard = (): Promise<Response> =>{
		return fetch(
			BACKEND_URL+"/country_leaderboard"
		);
	}

	increment_score = (increment_by: number) => {
		console.log(increment_by);
		this.remaining_score_to_add += increment_by;
		this.interval_id = setInterval(this.timer_callback, 10);
		if(this.token > 0 && ((this.score + increment_by) - this.last_update_score > 200)){
			this.last_update_score = this.score + increment_by;
			this.update_server(this.last_update_score).then(response => response.json()).then(data => {
				this.current_rank = data.ranking;
				this.total_games_played = data.total_games_played;
				console.log("rank " + data.ranking);
				const badge_span =  document.getElementById("score-badge") as HTMLElement;
				if(data.ranking == 0){
					badge_span.style.backgroundImage = "url(gold-medal.png)";
					badge_span.textContent = "";
				}
				else if(data.ranking == 1){
					badge_span.style.backgroundImage = "url(silver-medal.png)";
					badge_span.textContent = "";
				}
				else if(data.ranking == 2){
					badge_span.style.backgroundImage = "url(bronze-medal.png)";
					badge_span.textContent = "";
				}
				else{
					badge_span.style.backgroundImage = "";
					badge_span.textContent = "#" + (data.ranking + 1).toString();
				}
			});
		}
	}

	update_scoreboard = () =>{
		this.score_element.textContent = this.score.toString().padStart(6,'0');
	}
}